<div class="flex-label">
  @if (labelEdit) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ i18n.get('myName') }}</mat-label>
      <input type="text" matInput [ngModel]="session.getLabel()" (ngModelChange)="label.set($event)" maxlength="40" />
    </mat-form-field>
  } @else {
    <span class="label-span">{{ session.getLabel() }}</span>
  }
  <button mat-icon-button color="basic" (click)="toggleEditLabel()">
    @if (!labelEdit) {
      <mat-icon>edit</mat-icon>
    } @else {
      <mat-icon>save</mat-icon>
    }
  </button>
</div>
<hr />
@if (!offlineService.localOperation() && offlineService.isOnline()) {
  <div class="connections-container">
    <mat-slide-toggle
      color="primary"
      [ngModel]="showCurrentLocation()"
      (change)="state.updateShowCurrentLocation($any($event).checked)"
    >
      <mat-label>{{ i18n.get('shareLocation') }}</mat-label>
    </mat-slide-toggle>
    <hr />
    <mat-label class="font-semibold">{{ i18n.get('online') }}</mat-label>
    <mat-list>
      @for (connection of connections(); track connection) {
        <mat-list-item class="flex-container">
          <div class="flex-container-connection">
            <div class="flex-container-connection-label">
              <mat-icon mat-list-icon>person</mat-icon>
              <span>{{ connection.label }}</span>
            </div>
            @if (connection.currentLocation) {
              <button mat-icon-button color="primary" [title]="i18n.get('currentLocation')" (click)="centerMap(connection.currentLocation)">
                <mat-icon mat-list-icon>person_pin_circle</mat-icon>
              </button>
            }
          </div>
        </mat-list-item>
      }
    </mat-list>
  </div>
}
@if (!offlineService.isOnline()) {
  <div class="offline-container">
    <mat-icon>signal_wifi_off</mat-icon>
    <mat-label class="font-gray">{{ i18n.get('youAreOffline') }}</mat-label>
  </div>
}
<ng-template #workOfflineContent>
  <div class="local-container">
    <p>{{ i18n.get('localAvailabilityStepsIntro') }}</p>
    <button mat-flat-button color="primary" type="button" (click)="prepareLocalAvailability()">
      {{ i18n.get('prepareLocalAvailability') }}
    </button>
    <div class="task">
      @if (offlineService.downloadLocalBaseMap()) {
        <mat-icon>done</mat-icon>
      } @else {
        <mat-icon>report_problem</mat-icon>
      }
      <span class="task-text">{{ i18n.get('downloadLocalBaseMap') }}</span>
    </div>
    @if (offlineService.isLoadingBaseMap()) {
      <mat-progress-bar color="primary" class="map-progress" mode="determinate" [value]="mapProgress" />
    }
    <div class="task">
      @if (offlineService.useLocalBaseMap()) {
        <mat-icon>done</mat-icon>
      } @else {
        <mat-icon>report_problem</mat-icon>
      }
      <span class="task-text">{{ i18n.get('useLocalBaseMap') }}</span>
    </div>
    <div class="task">
      @if (offlineService.hideUnavailableLayers()) {
        <mat-icon>done</mat-icon>
      } @else {
        <mat-icon>report_problem</mat-icon>
      }
      <span class="task-text">{{ i18n.get('hideUnavailableLayers') }}</span>
    </div>
    <div class="task">
      @if (offlineService.downloadAvailableLayers()) {
        <mat-icon>done</mat-icon>
      } @else {
        <mat-icon>report_problem</mat-icon>
      }
      <span class="task-text">{{ i18n.get('downloadAvailableLayers') }}</span>
    </div>
    <div class="task">
      @if (offlineService.haveSearchCapability()) {
        <mat-icon>done</mat-icon>
      } @else {
        <mat-icon>report_problem</mat-icon>
      }
      <span class="task-text">{{ i18n.get('haveSearchCapability') }}</span>
      <mat-icon (click)="showSearchInfo($event)">info</mat-icon>
    </div>
  </div>
</ng-template>

@if (offlineService.localOperation()) {
  <ng-container>
    <ng-container [ngTemplateOutlet]="workOfflineContent"></ng-container>
  </ng-container>
} @else {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{ i18n.get('offlineData') }}</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container [ngTemplateOutlet]="workOfflineContent"></ng-container>
  </mat-expansion-panel>
}
